export var DIALOG_ACTIONS_CLASS_PREFIX = 'DialogActions';